<!-- فرم بودجه بندی -->
<template>
  <div class="row">
    <!-- منوهای بالای جدول اصلی -->
    <div class="col-12 p-0 mb-2">
      <div class="row p-0 d-flex justify-content-between align-items-center">
        <!-- جستجوی پیشرفته در لیست سرفصل حساب ها -->
        <div class="col-4 p-0 pb-2">
          <div class="input-group p-0">
            <input
              id="textTbBaseAccSearch"
              placeholder="جستجو پیشرفته در لیست سرفصل حساب ها (Enter)"
              type="text"
              class="form-control form-control-sm rounded-0"
              v-on:focus="$event.target.select()"
              v-on:keyup.enter="filterData($event.target.value)"
            />
            <div class="input-group-prepend rounded-0">
              <span
                class="
                  input-group-text input-group-box-size
                  bg-secondary
                  rounded-left
                  white-text
                "
              >
                <a v-on:click="filterData('Search')">
                  <i class="fas fa-search"></i>
                </a>
              </span>
            </div>
          </div>
        </div>
        <!-- منوهای سمت چپ -->
        <div
          class="col-7 p-0 d-flex justify-content-end align-items-center"
        >
          <div class="row w-100">
            <!-- جمع بودجه منابع -->
            <div 
              class="col border ml-1 p-0 py-1 d-flex flex-column justify-content-center align-items-center"
              style="background-color: #c9ffbc; color: #9933cc; box-shadow: rgb(0 0 0 / 10%) 0px 1px 5px; border-radius: 5px;"
            >
              <span class="h6 m-0 mt-1">
                جمع بودجه منابع
              </span>
              <span class="mt-1 h5 p-0 m-0">
                {{getSumTbBaseAccBudget(1) | numFormat}}
              </span>
            </div>
            <!-- جمع بودجه مصارف -->
            <div 
              class="col border ml-1 p-0 py-1 d-flex flex-column justify-content-center align-items-center"
              style="background-color: #ffcbd6; color: #9933cc; box-shadow: rgb(0 0 0 / 10%) 0px 1px 5px; border-radius: 5px;"
            >
              <span class="h6 m-0 mt-1">
                جمع بودجه مصارف
              </span>
              <span class="mt-1 h5 p-0 m-0">
                {{getSumTbBaseAccBudget(2) | numFormat}}
              </span>
            </div>
            <!-- تراز -->
            <div 
              class="col border p-0 py-1 d-flex flex-column justify-content-center align-items-center"
              style="color: #9933cc; box-shadow: rgb(0 0 0 / 10%) 0px 1px 5px; border-radius: 5px;"
              v-bind:style="(getSumTbBaseAccBudget(1) - getSumTbBaseAccBudget(2)) >= 0 ? 'background-color: #c1fde7;': 'background-color: #fffca2'"
            >
              <span class="h6 m-0 mt-1">
                تراز
              </span>
              <span class="mt-1 h4 p-0 m-0" style="direction: ltr;">
                {{getSumTbBaseAccBudget(1) - getSumTbBaseAccBudget(2) | numFormat}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- جدول لیست سرفصل حساب ها -->
    <ShowTableBaseAcc
      :key="1"
      v-bind:ParentCode = "0"
      v-bind:ListTbBaseAccData="setListTbBaseAcc"
      v-bind:isMultieSelect="isMultieSelect"
      v-bind:ListAllShowFilter="ListAllShowFilter"
    ></ShowTableBaseAcc>
  </div>
</template>

<script>
import ShowTableBaseAcc from "./Components/ShowTableBaseAcc.vue";

export default {
  name: 'ParentTable',
  components: {
    ShowTableBaseAcc,
  },
  data() {
    return {
      // لیست اصلی سرفصل حساب ها محلی
      ListTbBaseAcc: [],
      // لیست سطرهای در حال نمایش
      ListAllShowFilter: [],
      // کد سرفصل حساب جدید
      NewChildCode: 0,
      // کنترل وضعیت چند انتخابی
      isMultieSelect: true
    };
  },
  created() {
      this.getListTbBaseAcc();
  },
  computed: {
    setListTbBaseAcc(){
      this.ListTbBaseAcc = this.$store.getters.getAllTbBaseAccBudgetData;
      return this.ListTbBaseAcc;
    },
    // دریافت جمع کل هزینه ها یا درآمدها
    getSumTbBaseAccBudget(){
      return (NAccType) => {
        // NAccType = هزینه:2 - درآمد:1
        return this.$store.getters.getSumTbBaseAccBudget(NAccType);
      }
    },
  },
  methods: {
    // دریافت لیست سرفصل حساب ها از سرور
    async getListTbBaseAcc() {
        // دریافت اطلاعات کاربر جاری
        let token = await this.$store.getters.getUserData.token; // توکن کاربر
        let yearID = await this.$store.getters.getYearActive; // دریافت سال فعال
        // دریافت لیست حساب ها
        await this.$store.dispatch("getAllTbBaseAccDataFromSever", {
          yearID,
          token,
        });
    },
    // استخراج کد آخرین فرزند جهت درج سطر جدید
    getLastChildCode(){
      let tempCode = 0;
      this.getListChildLevel1().forEach(element => {
        if(element.NCode > tempCode){
          tempCode = element.NCode
        }
      });
      if(parseInt(tempCode) > 0){
        // افزایش یک واحدی کد آخرین فرزند
        return (parseInt(tempCode) + 1).toString();
      } else {
        // فرزندی یافت نشد / صدور کد جدید / تفصیلی سه صفر یک
        return '110';
      }
    },
    // استخراج فرزندان سطح یک
    getListChildLevel1() {
      let tempData = [];
      if (this.ListTbBaseAcc.length > 0) {
        // حساب کل
        tempData = this.ListTbBaseAcc.filter(function (item) {
          return item.NCode.toString().length == 3;
        });
      }
      return tempData;
    },    

    // جستجو در لیست حساب ها
    filterData(searchValue, event) {
      // اگر دکمه جستجو کلیک شود
      if (searchValue === "Search") {
        searchValue =
          $("#textTbBaseAccSearch").val() != ""
            ? $("#textTbBaseAccSearch").val()
            : "";
      }

      if (searchValue != "") {
        // فیلتر اطلاعات بر اساس مقدار درج شده توسط کاربر
        let ListTbBaseAccFilter =
          this.ListTbBaseAcc.filter(function(item){
            return (
                item.NCode.toString().startsWith(searchValue) ||
                item.SDesc.toString().includes(searchValue)
              )
            });
        if(ListTbBaseAccFilter.length > 0){
          // نمایش پیام تعداد جستجو
          this.$store.dispatch("notify", {
            notText: "به تعداد ( " + ListTbBaseAccFilter.length + " ) مورد پیدا شد .",
            color: "86ff3b",
            timeOut: 2500,
          });
          // ایجاد لیست سطرهای انتخاب شده و در حال نمایش
          this.ListAllShowFilter.length = 0  // خالی کردن لیست سطرهای در حال نمایش
          // متغییر محلی لیست سطرهای در حال نمایش
          let tempListShow = [];
          // متغییر محلی معادل لیست سرفصل ها
          let tempListTbBaseAcc = this.ListTbBaseAcc;  
          // اجرای حلقه به تعداد سطرهای جستجو شده
          ListTbBaseAccFilter.forEach(function(item){
            // استخراج تمام والدهای کد جستجو شده
            let listTemp = tempListTbBaseAcc.filter(function(value){
              // اگر کد برابر بود یا ابتدای کد برابر بود
              return value.NCode == item.NCode || 
              item.NCode.toString().startsWith(value.NCode)
            });
            // استخراج کد تمام والدها
            listTemp.forEach(function(val) { 
                if(tempListShow.findIndex((find) => find == val.NCode) == -1){
                  tempListShow.push(val.NCode)
                }
              });
          });

          this.ListAllShowFilter = tempListShow;
        } else {
          this.$store.dispatch("notify", {
            notText: "برای مقدار ( " + searchValue + " ) موردی پیدا نشد !",
            timeOut: 2500,
          });
        }
      } 
    },
  },
};
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}
.rowBoxShadow {
  box-shadow: rgb(126 72 156 / 15%) 0px -2px 3px;
}
.tdGradient {
  background: linear-gradient(rgba(233, 233, 233, 0.4), rgba(255, 255, 255, 1));
}
.tdGradient2 {
  background: linear-gradient(
    rgba(233, 233, 233, 0.4),
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1)
  );
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/Budgeting/Budgeting.vue